module.exports = __webpack_public_path__ + "img/training-top-m.e44430b9.jpg";